import { ArrowRight, ExternalLink } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";

const rafhaLogo = "https://customer-assets.emergentagent.com/job_choice-omw-launch/artifacts/66p7nc88_Rapha%20Entertainment%20Logo.png";
const choiceLogo = "https://customer-assets.emergentagent.com/job_choice-omw-launch/artifacts/zcquxkzd_IMG_0221.png";
const omwLogo = "https://customer-assets.emergentagent.com/job_choice-omw-launch/artifacts/9qq41nid_original-logos_2019_Oct_8089-5dab77750dc93.jpeg";

const solutions = [
  {
    name: "Rafha Entertainment",
    tagline: "Elevate Your Celebration",
    description: "A premium entertainment marketplace featuring curated, vetted professionals. Book DJs, photographers, musicians, caterers and more — all licensed and insured.",
    logo: rafhaLogo,
    website: "https://rafhaentertainment.com",
    color: "from-orange-500/20 to-rose-500/20",
    borderColor: "border-orange-500/30",
    isNew: true,
  },
  {
    name: "Choice Mobile Celebrations",
    tagline: "Celebrate Life — Right Where You Are",
    description: "Our luxury mobile van brings unforgettable celebration experiences directly to you in Montgomery, AL. Birthday pull-ups, serenades, and milestone celebrations.",
    logo: choiceLogo,
    website: "https://rafhaentertainment.com/choice-mobile",
    color: "from-amber-500/20 to-yellow-500/20",
    borderColor: "border-amber-500/30",
    isNew: true,
  },
  {
    name: "OMW Business & Financial Resources",
    tagline: "Build Your Business With Confidence",
    description: "Veteran-owned business consulting firm and home of the Business Bootcamp Institute. From startup to success, we've helped 500+ businesses thrive.",
    logo: omwLogo,
    website: "https://www.omwbusiness.com",
    color: "from-emerald-500/20 to-teal-500/20",
    borderColor: "border-emerald-500/30",
    isNew: false,
  },
];

const Solutions = () => {
  return (
    <section id="solutions" className="py-20 lg:py-28 bg-muted/30">
      <div className="container mx-auto px-6">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="inline-flex items-center gap-2 text-primary mb-4">
            <span className="w-8 h-0.5 bg-primary rounded-full" />
            <span className="text-sm font-semibold uppercase tracking-wider">My Solutions</span>
            <span className="w-8 h-0.5 bg-primary rounded-full" />
          </div>
          
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-6">
            Ways We Can Work Together
          </h2>
          
          <p className="text-lg text-muted-foreground">
            From entertainment and celebrations to business consulting — discover how my ventures can serve you.
          </p>
        </div>

        {/* Solutions Grid */}
        <div className="grid md:grid-cols-3 gap-8">
          {solutions.map((solution, index) => (
            <Card 
              key={solution.name}
              className={`group relative overflow-hidden border-2 ${solution.borderColor} bg-card hover:shadow-xl transition-all duration-500 hover:-translate-y-2`}
            >
              {/* Background gradient */}
              <div className={`absolute inset-0 bg-gradient-to-br ${solution.color} opacity-0 group-hover:opacity-100 transition-opacity duration-500`} />
              
              <CardContent className="relative p-6 flex flex-col h-full">
                {/* Logo & Badge */}
                <div className="flex items-start justify-between mb-4">
                  <div className="w-20 h-20 bg-white rounded-xl p-2 shadow-md flex items-center justify-center">
                    <img 
                      src={solution.logo} 
                      alt={solution.name} 
                      className="w-full h-full object-contain"
                    />
                  </div>
                  {solution.isNew && (
                    <Badge className="bg-primary/10 text-primary border-primary/20">NEW</Badge>
                  )}
                </div>

                {/* Content */}
                <h3 className="font-display text-xl font-bold text-foreground mb-2 group-hover:text-primary transition-colors">
                  {solution.name}
                </h3>
                <p className="text-sm text-primary font-medium italic mb-3">
                  "{solution.tagline}"
                </p>
                <p className="text-muted-foreground text-sm leading-relaxed mb-6 flex-grow">
                  {solution.description}
                </p>

                {/* CTA */}
                <Button asChild variant="outline" className="w-full group/btn">
                  <a href={solution.website} target="_blank" rel="noopener noreferrer">
                    Learn More
                    <ExternalLink className="w-4 h-4 ml-2 group-hover/btn:translate-x-1 transition-transform" />
                  </a>
                </Button>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Solutions;
